import React from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField } from '@mui/material';
import BaseField from './BaseField';

/**
 * PhoneField component for workflow forms.
 * Extends the BaseField with phone input functionality and validation.
 */
const PhoneField = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  required,
  error,
  helperText,
  disabled,
  fullWidth,
  className,
  inputProps,
  ...rest
}) => {
  // Format phone number as user types
  const handleChange = (e) => {
    const { value } = e.target;
    // Allow only digits, plus sign, spaces, and hyphens
    if (value === '' || /^[0-9+\s-]*$/.test(value)) {
      onChange(e);
    }
  };

  return (
    <BaseField
      id={id}
      name={name}
      label={label}
      required={required}
      error={error}
      helperText={helperText || 'Format: +XX XXXX XXXXXX'}
      disabled={disabled}
      fullWidth={fullWidth}
      className={className}
    >
      <MuiTextField
        id={id}
        name={name}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        variant="outlined"
        fullWidth={fullWidth}
        disabled={disabled}
        error={Boolean(error)}
        type="tel"
        size="small"
        inputProps={{
          pattern: '\\+?[0-9]{10,15}',
          ...inputProps,
        }}
        {...rest}
      />
    </BaseField>
  );
};

PhoneField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};

PhoneField.defaultProps = {
  required: false,
  disabled: false,
  fullWidth: true,
  value: '',
  placeholder: '+XX XXXX XXXXXX',
};

export default PhoneField;
